<template>
  <div>
    <section class="subpage-head">
      <div class="container">
        <h1>Subscriptions</h1>
        <router-link :to="{name: 'user.profile2'}" class="shtool">Manage my profile</router-link>
      </div>
    </section>
    
    
    <section class="gen-list">
      <div class="container">
        <div class="gs-head">
          <h2>My Subscriptions</h2>
        </div>
        <ul class="gen-list-content pkg-list">
          <li v-for="pkg in packages" v-if="!pkg.type2" :class="{highlight: isHighlighted(pkg)}">
            <h2 v-html="fancyTitle(pkg.title)"></h2>
            <img :src="'files/'+pkg.photo" />
            <p v-html="textToHtml(pkg.description)"></p>
            <div class="subsc-details">
              <p class="not-subscribed" v-if="!activePayment(pkg)">
                Not subscribed
              </p>
              <p class="subscribed" v-else>
                <span>Expires:</span>
                <em>{{ formatDate(activePayment(pkg).endDate, "MMM Do YYYY") }}</em>
              </p>
            </div>
            <template v-if="pkg.priceUsd">
              <div class="option">
                <p>30 days <em>{{ formatPriceP(pkg.priceUsd) }}</em></p>
                <a class="buy-btn" href="" v-on:click.prevent="select(pkg, 0)">{{ !activePayment(pkg)?'Subscribe':'Extend' }}</a>
              </div>
              <div class="option">
                <p>3 months <em>{{ formatPriceP(pkg.renewPriceUsd) }}</em></p>
                <a class="buy-btn" href="" v-on:click.prevent="select(pkg, 1)">{{ !activePayment(pkg)?'Subscribe':'Extend' }}</a>
              </div>
              <div class="option">
                <p>6 months <em>{{ formatPriceP(pkg.renewPrice2Usd) }}</em></p>
                <a class="buy-btn" href="" v-on:click.prevent="select(pkg, 2)">{{ !activePayment(pkg)?'Subscribe':'Extend' }}</a>
              </div>
              <div class="option">
                <p>1 year <em>{{ formatPriceP(pkg.renewPrice3Usd) }}</em></p>
                <a class="buy-btn" href="" v-on:click.prevent="select(pkg, 3)">{{ !activePayment(pkg)?'Subscribe':'Extend' }}</a>
              </div>
            </template>
            <template v-else>
              <div class="option option-one">
                <p>these videos are available only to PPATT members</p>
                <a class="buy-btn buy-btn-one" href="" v-on:click.prevent="">Request access</a>
              </div>
            </template>
          </li>
          <li v-for="pkg in packages" v-if="pkg.type3" class="aio" :class="{highlight: isHighlighted(pkg)}">
            <h2 v-html="fancyTitle(pkg.title)"></h2>
            <div class="details">
            <img :src="'files/'+pkg.photo" />
            </div>
            <div class="subsc-opts">
              <p v-html="textToHtml(pkg.description)"></p>
              <div class="subsc-details">
                <p class="not-subscribed" v-if="!activePayment(pkg)">
                  Not subscribed
                </p>
                <p class="subscribed" v-else>
                  <span>Expires:</span>
                  <em>{{ formatDate(activePayment(pkg).endDate, "MMM Do YYYY") }}</em>
                </p>
              </div>
              <template v-if="pkg.priceUsd">
              <div class="option">
                <p>
                  30 days
                  <i>
                    <em>{{ formatPriceP(pkg.priceUsd) }}</em>
                    <span v-if="pkg.priceEur*1">instead of <strong>{{ formatPriceP(pkg.priceEur) }}</strong></span>
                  </i>
                </p>
                <a class="buy-btn" href="" v-on:click.prevent="select(pkg, 0)">{{ !activePayment(pkg)?'Subscribe':'Extend' }}</a>
              </div>
              <div class="option">
                <p>
                  3 months
                  <i>
                    <em>{{ formatPriceP(pkg.renewPriceUsd) }}</em>
                    <span v-if="pkg.renewPriceEur*1">instead of <strong>{{ formatPriceP(pkg.renewPriceEur) }}</strong></span>
                  </i>
                </p>
                <a class="buy-btn" href="" v-on:click.prevent="select(pkg, 1)">{{ !activePayment(pkg)?'Subscribe':'Extend' }}</a>
              </div>
              <div class="option">
                <p>
                  6 months
                  <i>
                    <em>{{ formatPriceP(pkg.renewPrice2Usd) }}</em>
                    <span v-if="pkg.renewPrice2Eur*1">instead of <strong>{{ formatPriceP(pkg.renewPrice2Eur) }}</strong></span>
                  </i>
                </p>
                <a class="buy-btn" href="" v-on:click.prevent="select(pkg, 2)">{{ !activePayment(pkg)?'Subscribe':'Extend' }}</a>
              </div>
              <div class="option">
                <p>
                  1 year
                  <i>
                    <em>{{ formatPriceP(pkg.renewPrice3Usd) }}</em>
                    <span v-if="pkg.renewPrice3Eur*1">instead of <strong>{{ formatPriceP(pkg.renewPrice3Eur) }}</strong></span>
                  </i>
                </p>
                <a class="buy-btn" href="" v-on:click.prevent="select(pkg, 3)">{{ !activePayment(pkg)?'Subscribe':'Extend' }}</a>
              </div>
            </template>
            <template v-else>
              <div class="option option-one">
                <p>these videos are available only to PPATT members</p>
                <a class="buy-btn buy-btn-one" href="" v-on:click.prevent="">Request access</a>
              </div>
            </template>
            </div>
          </li>
        </ul>
      </div>
    </section>
    
    <section class="gen-list" v-if="videos.length">
      <div class="container">
        <div class="gs-head">
          <h2>My Videos and Tests</h2>
        </div>
        <ul class="gen-list-content pkg-list vidpkg-list">
          <li v-for="item in videos" :class="{vid: item.media && item.media.store.id!=1}">
            <div class="preview">
              <img v-if="item.media && mediaUrl(item.media).indexOf('pdf')==-1" :src="mediaUrl(item.media, item)" />
              <span class="video"></span>
              <span class="cat">{{ item.type && item.type.title }}</span>
              <span class="stat">{{ "" }}</span>
            </div>
            <div class="desc">
              <h5><a href="">
                <em v-if="item.parent?item.parent.subtitle:item.subtitle">{{ item.parent?item.parent.subtitle:item.subtitle }}</em>
                <span v-html="formatTitle(item.title)+formatMore(item.allVideos)"></span>
              </a></h5>
              <div class="subsc-details">
                <p class="subscribed" v-if="activePaymentVid(item)">
                  <span>Expires:</span>
                  <em>{{ formatDate(activePaymentVid(item).endDate, "MMM Do YYYY") }}</em>
                </p>
              </div>
              <date>{{ formatDate(item.created, "MMM Do, YYYY") }}</date>
            </div>
            <template v-if="item.priceUsd">
              <div class="option" v-if="item.priceUsd*1">
                <p>1 day <em>{{ formatPriceP(item.priceUsd) }}</em></p>
                <a class="buy-btn" href="" v-on:click.prevent="selectVid(item, 0)">Extend</a>
              </div>
              <div class="option" v-if="item.price1*1">
                <p>3 days <em>{{ formatPriceP(item.price1) }}</em></p>
                <a class="buy-btn" href="" v-on:click.prevent="selectVid(item, 1)">Extend</a>
              </div>
              <div class="option" v-if="item.price2*1">
                <p>7 days <em>{{ formatPriceP(item.price2) }}</em></p>
                <a class="buy-btn" href="" v-on:click.prevent="selectVid(item, 2)">Extend</a>
              </div>
              <div class="option" v-if="item.price3*1">
                <p>30 days <em>{{ formatPriceP(item.price3) }}</em></p>
                <a class="buy-btn" href="" v-on:click.prevent="selectVid(item, 3)">Extend</a>
              </div>
              <div class="option" v-if="item.price4*1">
                <p>90 days <em>{{ formatPriceP(item.price4) }}</em></p>
                <a class="buy-btn" href="" v-on:click.prevent="selectVid(item, 4)">Extend</a>
              </div>
            </template>
            <template v-else>
              <div class="option option-one">
                <p>this video is available only to PPATT members</p>
                <a class="buy-btn buy-btn-one" href="" v-on:click.prevent="">Request extension</a>
              </div>
            </template>
            <router-link :to="{name: 'content', params: {id: item.id}}" class="wlink"></router-link>
          </li>
        </ul>
      </div>
    </section>




  </div>
</template>
<script>
import api from './api';
import dateLimit from './dateLimit';
import formatters from './formatters';
import payment from './payment';

export default {
  mixins: [dateLimit, formatters, payment],
  data: ()=>({
    videos: [],
    searchTerm: '',
    userProfile: window.appRoot.loggedIn || {activePayments: [], allPayments: []},
    packages: [],
    selectedType: null,
  }),
  computed: {
  },
  methods: {
    formatMore(relVideos) {
      if (!relVideos || !relVideos.length)
        return "";
      return " <em>+ "+(relVideos.length-1)+" videos</em>";
    },
    isHighlighted(pkg) {
      if (this.selectedType===null)
        return false;
      return pkg.type==this.selectedType || pkg.type2==this.selectedType ||
             pkg.type3==this.selectedType || pkg.type4==this.selectedType ||
             pkg.type5==this.selectedType || pkg.type6==this.selectedType;
    },
    activePayment(pkg) {
      var payment=this.paymentForGroup(pkg.id);
      return payment && payment.isActive?payment:null;
    },
    activePaymentVid(video) {
      var payment=this.paymentForVideo(video.id);
      return payment && payment.isActive?payment:null;
    },
    introText(item) {
      var text=[];
      var blocks=(item.blocks || []).slice().sort((a,b)=>{
        if (a.order_index<b.order_index) return -1;
        if (a.order_index>b.order_index) return 1;
        return 0;
      });
      for(var block of blocks) {
        text.push(block.content);
      }
      text=text.map((a)=>a.replace(/\<[^>]*\>/g, "").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&[a-z]+;/g, ""));
      return text.join(" ").substring(0, 180);
    },
    mediaUrl(obj) {
      if (!obj)
        return null;
      var rootUrl="";
      if (obj.store && obj.store.rootUrl)
        rootUrl=obj.store.rootUrl;
      if (obj.thumbnail)
        return rootUrl+obj.path.replace(/\/[^/]*$/, "/")+obj.thumbnail;
      else
        return rootUrl+obj.path;
    },
    textToHtml(text) {
      text=(text || "")+"";
      text=text.replace(/\n/g, "<br />");
      return text;
    },
    fancyTitle(text) {
      text=this.textToHtml(text);
      text=text.replace(/\(/g, "<span>");
      text=text.replace(/\)/g, "</span>");
      return text;
    },
    select(item, variant) {
      appCart.pushItem("g", item.id, variant || "");
    },
    selectVid(item, variant) {
      appCart.pushItem("v", item.id, variant || "");
    },
    async loadPackages() {
      this.packages=(await api.list("VideoGroup", {}, ["orderindex:ASC"])).items;
      this.packages=this.packages.filter((pkg)=>{
        if (this.userProfile.hasPpatt)
          return true;
        if (pkg.type==4)
          return false;
        return true;
      });
    },
    async loadVideos() {
      var videoIds=this.paymentActive().map(a=>a.video).filter(a=>a);
      var videos=[]
      if (videoIds.length)
      for(var video of (await api.list("Video", {"id": ["IN ("+videoIds.join(",")+")"]}, [], 0, 0, ["author"])).items) {
        var payment=this.paymentForVideo(video.id);
        if (payment && payment.isActive) {
          video.payment=payment;
          videos.push(video);
        }
      }
      this.videos=videos;
    },
  },
  mounted() {
    this.loadPackages();
    this.loadVideos();
    if (window.videoType) {
      this.selectedType=window.videoType;
      delete window.videoType;
    }
  },
  
}
</script>
